import { MIN_APPROVAL_INFO_COUNT } from "common/constants";

type ReferenceChecker =
  | { [itemCode: string]: { count: number; totalLength?: number; totalBytes?: number } }
  | undefined;

/**
 * "허가사항 보기" 버튼 노출 조건.
 * itemCode가 있고, 허가사항 레코드가 충분(count ≥ MIN_APPROVAL_INFO_COUNT)할 때만 true.
 * count === -1(크롤링 중) / 0~부족 / itemCode 없음 / referenceChecker 미존재 → false.
 */
export function canShowDrugLabel(
  itemCode: string | undefined,
  referenceChecker: ReferenceChecker
): itemCode is string {
  return !!itemCode && (referenceChecker?.[itemCode]?.count ?? -1) >= MIN_APPROVAL_INFO_COUNT;
}
